module.exports = __webpack_public_path__ + "img/d00feb92c46c1be1409593875bd7cdf3.svg";